import { KineticHero } from "./KineticHero";
import { BrandMarquee } from "./BrandMarquee";
import { Stats } from "./Stats";
import { Services } from "./Services";
import { Manifesto } from "./Manifesto";
import { Portfolio } from "./Portfolio";
import { Contact } from "./Contact";

export const HomePage = () => {
  return (
    <main data-testid="home-page">
      <KineticHero />
      <BrandMarquee />
      <Stats />
      <Services />
      <Manifesto />
      <Portfolio />
      <Contact />
    </main>
  );
};
